import Vue from "vue";
import Antd from "ant-design-vue";
import VueCookies from "vue-cookies";
import App from "./App.vue";
import store from "./store";
import "ant-design-vue/dist/antd.css";
import VueClipboard from "vue-clipboard2";
import VueTextareaAutosize from "vue-textarea-autosize";

Vue.config.productionTip = false;

window.st = store.state;

Vue.use(Antd);
Vue.use(VueCookies);
Vue.use(VueClipboard);
Vue.use(VueTextareaAutosize);

new Vue({
  store,
  render: h => h(App)
}).$mount("#app");
